var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{attrs:{"gutter":20}},_vm._l((_vm.gridData),function(c,i){return _c('el-col',{key:i,attrs:{"span":6}},[_vm._t("default")],2)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }